import factory from './factory'

export default {
  all: factory.all,
  providers: factory.providers,
  countries: factory.countries,
  regions: factory.regions,
  ordered: factory.ordered,
  filtered: factory.filtered,
  appliedFilters: factory.appliedFilters
}
